var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoNhg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "23.399999618530273 29.299999237060547 180.10000610351562 111.19999694824219",
    style: {
      enableBackground: "new 0 0 230.8 170.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:url(#SVGID_1_);}")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 23.43,
    y1: 87.115,
    x2: 203.47,
    y2: 87.115,
    gradientTransform: "matrix(1 0 0 -1 0 172)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E50051"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#A066A7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0086CD"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.5,57.9l13.9,13.9v37.6l-2.5,2.5H60.3l-2.5-2.5V77.5H43.1v31.9l-2.5,2.5H25.9l-2.5-2.5v-49l2.5-2.5h9 l2.5,2.5h3.2l2.5-2.5H63.5z M111.8,57.9l-5.7,5.7V31.8l-2.5-2.5H88.9l-2.5,2.5v77.6l2.5,2.5h14.7l2.5-2.5V77.5h14.7l0,31.9l2.5,2.5 H138l2.5-2.5V71.8l-13.9-13.9H111.8z M201,57.9l2.5,2.5v66.2l-13.9,13.9h-26.2l-8.2-8.2v-9l2.5-2.5h9l5.7,5.7h8.2l3.2-3.2v-11.4 h-5.7h-14.7L149.4,98V71.8l13.9-13.9h20.4l2.5,2.5h3.2l2.5-2.5H201z M183.8,77.6h-14.7v14.7h14.7L183.8,77.6L183.8,77.6z  M181.3,92.2h2.5v-2.5L181.3,92.2z M183.8,80v-2.5h-2.5L183.8,80z M171.6,77.6h-2.5V80L171.6,77.6z M120.8,80v-2.5h-2.5L120.8,80z  M108.6,77.6h-2.5V80L108.6,77.6z M57.8,80v-2.5h-2.5L57.8,80z M45.6,77.6h-2.5V80L45.6,77.6z M169.1,89.8v2.5h2.5L169.1,89.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNhg);
export default __webpack_public_path__ + "static/media/logo_nhg.c32658b18586821590c2a2d6b0f657be.svg";
export { ForwardRef as ReactComponent };